import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import { MessageService } from "primeng/api";
@Component({
  selector: 'app-awards',
  templateUrl: './awards.component.html',
  styleUrls: ['./awards.component.css']
})
export class AwardsComponent implements OnInit {
  awards:any=[]
  Category:any
  constructor(
    private router: Router,
    public global: GlobalService,
    private route: ActivatedRoute,
    private messageService: MessageService,
  ) { 
  }

  ngOnInit(): void {
    this.Category=this.route.snapshot.paramMap.get('id');
    const id = this.route.snapshot.paramMap.get('id');
    this.getAwards(id)
  }

  getAwards(id:any) {
    const url =
      this.global.basePath +
      "common/circularlist?modelType=awardee&awardName="+ id;
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      console.log(
        "🚀 ~ file: archers.component.ts ~ line 30 ~ ArchersComponent ~ this.global.GetRequest ~ res",
        res
      );
      const data = res[0].json.circular;
      this.awards = data.reverse();
    });
  }

}
